// require('./bootstrap');

import store, { registry } from 'Stores/';
import agency from 'Stores/agency';
import contact from 'Stores/contact';
import contactUs from 'Stores/contactUs';
import employerDetails from 'Stores/employerDetails';
import industry from 'Stores/industry';
import info from 'Stores/info';
import location from 'Stores/location';
import search from 'Stores/search';
import pageText from 'Stores/pagetext';
import laravelSession from 'Stores/laravelSession';

import { h } from 'vue';

import App from './App.vue';

import employerCallback from 'Stores/employerCallback';

registry.add('search', search);
registry.add('contact', contact);
registry.add('info', info);
registry.add('industry', industry);
registry.add('location', location);
registry.add('contactUs', contactUs);
registry.add('employerDetails', employerDetails);
registry.add('employerCallback', employerCallback);
registry.add('pagetext', pageText);
registry.add('agency', agency);
registry.add('laravelSession', laravelSession);

const appConfig = {
  store,
  render: () => h(App),
  // render: () => h('div'),
};

export default appConfig;
